import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#003D66",
    "fill-opacity": ".9",
    d: "M13 5v3H5v4h8v3l5.25-5L13 5Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#61C7F2",
    d: "M14 7.333 16.8 10 14 12.667V11H6V9h8V7.333Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#3B3B3B",
    "fill-opacity": ".9",
    d: "M2 3V1H1v18h1V3Z"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "logout-button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.session.logout()))
  }, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createVNode(_component_Button, { class: "p-button-text p-button-rounded ml-1" }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ])
  ]))
}